import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/shop'

export default {
	//列表接口
	getPageList(params) {
		params = params && commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL + '/getPageList',
			method: 'get',
			params,

		})
	},

	//导出excel
	exportExcel(params) {
		params = params && commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL + '/exportExcel',
			method: 'get',
			params,

		})
	},

	//添加
	add(data) {
		return request({
			url: BASE_URL + '/add',
			method: 'post',
			data
		})
	},



	//编辑
	update(data) {
		return request({
			url: BASE_URL + '/update',
			method: 'post',
			data
		})
	}
}